import { SportSummaryType } from '@/components/Sport/types';
import store from '@/store';

export enum StatusIds {
  UPCOMING = 1,
  LIVE,
  COMPLETED,
}

export const sportIds: { [key in SportSummaryType]: string } = {
  football: '9f6d655c-1790-46a6-9bfb-2c45ae71dd4a',
  rugby: '8278e65c-6c8a-4527-9941-cd001dca9382',
  cricket: '4b7545b9-d7fc-40e4-9822-9a0df3158c7a',
  golf: '08f55930-91e5-4777-96c8-c227ca8f2bb9',
  motorsport: 'f36d025c-bc24-4060-85a8-998c28f2aaac',
  tennis: 'f6ce6e56-bd27-41f8-a99f-5d628e0efcb3',
  cycling: '026b8971-17d2-479c-9f3b-30e93d76adf1',
  wrestling: 'e8a0f5a4-c5d4-46e7-b04e-c4cb28fadb2f',
  athletics: '3491cd97-e05c-4b80-bd83-8e66cbe8c0eb',
  boxing: '3a221084-d955-485d-bd35-85d40b2470ac',
  aquatics: 'afa61a49-5594-42c4-8a0c-445824684704',
  olympics: '1a4e0cb8-8290-4347-82d4-4b899432df9c',
};

export const sportsBackgrounds = {
  '9f6d655c-1790-46a6-9bfb-2c45ae71dd4a': { background: 'images/backgrounds/football@2x.jpg' },
  '8278e65c-6c8a-4527-9941-cd001dca9382': { background: 'images/backgrounds/rugby@2x.jpg' },
  '4b7545b9-d7fc-40e4-9822-9a0df3158c7a': { background: 'images/backgrounds/cricket@2x.jpg' },
  '08f55930-91e5-4777-96c8-c227ca8f2bb9': { background: 'images/backgrounds/golf@2x.jpg' },
  'f36d025c-bc24-4060-85a8-998c28f2aaac': { background: 'images/backgrounds/motorsport@2x.jpg' },
  'f6ce6e56-bd27-41f8-a99f-5d628e0efcb3': { background: 'images/backgrounds/tennis@2x.jpg' },
  '026b8971-17d2-479c-9f3b-30e93d76adf1': { background: 'images/backgrounds/football@2x.jpg' },
  'e8a0f5a4-c5d4-46e7-b04e-c4cb28fadb2f': { background: 'images/backgrounds/football@2x.jpg' },
  '3491cd97-e05c-4b80-bd83-8e66cbe8c0eb': { background: 'images/backgrounds/football@2x.jpg' },
  '3a221084-d955-485d-bd35-85d40b2470ac': { background: 'images/backgrounds/football@2x.jpg' },
  'afa61a49-5594-42c4-8a0c-445824684704': { background: 'images/backgrounds/football@2x.jpg' },
  '1a4e0cb8-8290-4347-82d4-4b899432df9c': { background: 'images/backgrounds/football@2x.jpg' },
} as { [key: string]: { background: string } };

const defaultTabs = [
  {
    name: 'Tables',
    path: 'table',
  },
];

const golfTabs = () => {
  switch (store.state.selectedTournament.legacyId) {
    case 'us-pga-tour':
      return [
        {
          name: 'FedEx Cup',
          path: 'fedex-cup-standings',
        },
        {
          name: 'Money List',
          path: 'money-list',
        },
      ];
    case 'european-tour':
      return [
        {
          name: 'Race to Dubai',
          path: 'race-to-dubai',
        },
      ];
    case 'sa-golf':
      return [
        {
          name: 'Order of Merit',
          path: 'order-of-merit',
        },
      ];
    default:
      return [];
  }
};

export const getSportContextTabs: () => SportTab[] = () => {
  switch (store.state.navigationState.sport) {
    case sportIds.football:
    case sportIds.rugby:
    case sportIds.cricket:
      return [
        {
          name: 'Matches',
          path: 'scores',
        },
      ];
    case sportIds.tennis:
    case sportIds.golf:
      return [
        {
          name: 'Scores',
          path: 'scores',
        },
      ];
    case sportIds.motorsport:
      return [
        {
          name: 'Races',
          path: 'scores',
        },
      ];
    case sportIds.cycling:
    case sportIds.wrestling:
    case sportIds.athletics:
    case sportIds.boxing:
    case sportIds.aquatics:
    case sportIds.olympics:
      return [];
    default:
      return defaultTabs;
  }
};

export const getTournamentContextTabs: () => SportTab[] = () => {
  switch (store.state.navigationState.sport) {
    case sportIds.football:
      return [
        ...defaultTabs,
        {
          name: 'Top Scorers',
          path: 'top-scorers',
        },
      ];
    case sportIds.rugby:
    case sportIds.cricket:
      return defaultTabs;
    case sportIds.golf:
      return golfTabs();
    case sportIds.motorsport:
      return [
        {
          name: 'Driver Standings',
          path: 'driver-standings',
        },
        {
          name: 'Team Standings',
          path: 'team-standings',
        },
      ];
    case sportIds.tennis:
      return store.state.selectedTournament.legacyId === 'wta' || store.state.selectedTournament.legacyId === 'atp'
        ? [
          {
            name: 'Rankings',
            path: 'rankings',
          },
          {
            name: store.state.selectedTournament.legacyId === 'wta'
              ? 'Race to Shenzhen'
              : store.state.selectedTournament.legacyId === 'atp'
                ? 'Race to London'
                : 'Race',
            path: 'race',
          },
        ]
        : [];
    case sportIds.cycling:
    case sportIds.wrestling:
    case sportIds.athletics:
    case sportIds.boxing:
    case sportIds.aquatics:
    case sportIds.olympics:
      return [];
    default:
      return defaultTabs;
  }
};

export type SportTab = {
  name: string,
  path: string,
};

export const getFootballEventIcon = (eventType: string) => {
  const iconTypes = [
    'end-1',
    'end-2',
    'substitution',
    'yellow-card',
    'red-card',
    'goal',
    'own-goal',
  ];

  const eventIconMap: { [key: string]: string } = {
    'end-2': 'whistle',
    'end-1': 'whistle',
    substitution: 'substitution',
    'yellow-card': 'yellow-card',
    'red-card': 'red-card',
    goal: 'ball',
    'own-goal': 'red-ball',
  };

  return iconTypes.includes(eventType)
    ? `svg/football/match/${eventIconMap[eventType]}.svg`
    : undefined;
};
